import { Provider } from '@angular/core';

import { LicensePlatesUseCasesImpl } from '@app/domain/use-cases/ptrab/license-plates/license-plates.use-cases';
import { LICENSE_PLATES_USE_CASES } from '@app/domain/use-cases/ptrab/license-plates/license-plates.use-cases.contract';

export const licensePlatesUseCasesProvider: Provider = {
  provide: LICENSE_PLATES_USE_CASES,
  useClass: LicensePlatesUseCasesImpl
};
